// in src/posts.js
import React from 'react';
import {BooleanField, ImageField, ImageInput, DeleteButton, BooleanInput, ShowButton, DateField, RichTextField, Show, SimpleShowLayout, SimpleList, Filter, List, Edit, Create, Datagrid, ReferenceField, TextField, EditButton, ReferenceInput, required, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { RichTextInput } from 'ra-input-rich-text';
import Dropzone from 'react-dropzone'
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

const ServicesQualifyFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="name" alwaysOn />
    </Filter>
);

export const ServicesQualifyList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List {...props} title="Categorías - Calificar Servicio" filters={<ServicesQualifyFilter />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                    tertiaryText={record => new Date(record.createdAt).toLocaleDateString()}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="name" label="Título" />
                    <EditButton />
                    <ShowButton />
                    <DeleteButton />
                </Datagrid>
            )}
        </List>
    );
};

const ServicesQualifyName = ({ record }) => {
    return <span>ServicesQualify {record ? `"${record.name}"` : ''}</span>;
};

export const ServicesQualifyEdit = (props) => (
    <Edit title={<ServicesQualifyName />} {...props}>
        <SimpleForm>
            <TextInput source="id" disabled/>
            <TextInput source="name" label="Título" validate={[Validators.required]}/>
        </SimpleForm>
    </Edit>
);

export const ServicesQualifyCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="name" label="Título" validate={[Validators.required]}/>
        </SimpleForm>
    </Create>
);

export const ServicesQualifyShow = (props) => (
    <Show title={<ServicesQualifyName />} {...props}>
        <SimpleShowLayout>
            <TextField source="name" label="Título"/>
            <DateField label="Fecha de Actualización" source="updatedAt" />
            <DateField label="Fecha de Publicación" source="createdAt" />
        </SimpleShowLayout>
    </Show>
);
